// en.js
export default {
    lang:'language',
    menu:{
        supportApp: 'Application',
        supportBank: 'Banks',
        openProcess: 'Process',
        successCase: 'Success Cases',
        partners: 'Partners',
        contactUs: 'Contact'
    },
    tabs:{
        safe: 'Security',
        safeContent: 'Full Data Encryption',
        flexible: 'Flexible',
        flexibleContent: 'cloud deployment and local deployment are flexible and optional',
    },
    stayTuned: 'Stay tuned',
    supportAppPlatform:{
        title: 'Application',
        nsPlatform: 'Bank and enterprise direct connection solution',
        nscontent: "The client installed on the customer's finance dedicated computer regularly rounds middleware services to obtain payment and other instructions from the business system, decrypts them with preset passwords, and executes corresponding bank operations to achieve a direct connection between the business and the bank. This solution has no security risks, and the instructions are encrypted throughout the transmission process. The client is installed on an internal network computer, and there is no risk of external network exposure. The execution results of instructions are regularly fed back to the business system, and the entire process is recorded and well documented.",
        nsCorrespondingBank: 'Counterpart bank',
        otherPlatform: 'Other applications'
    },
    openProcess:{
        stepOne:{
            title: 'Bank',
            contentOne: 'The enterprise applies to the bank for a license to open',
            contentTwo: 'a direct connection between the bank and the enterprise'
        },
        stepTwo:{
            title: 'Bank and enterprise direct connection platform',
            contentOne: 'Register platform users',
            contentTwo: 'open permissions'
        },
        stepThree:{
            title: 'ERP application side',
            contentOne: 'Installation settings',
            contentTwo: 'implementation debugging'
        },
        stepFour:{
            title: 'Remove obstacles from',
            contentOne: 'Functional testing',
            contentTwo: 'officially launched'
        }
    },
    successCase:{
        yingtongTechnology: 'Airdoc',
        contentOne: '1.Accounting information is synchronized between the bank and the enterprise. Reflect the changes of account funds in real time, which is convenient for enterprise financial monitoring and decision-making; Match the capital flow with the business flow.',
        contentTwo: '2.Centralized management of funds. Establish a fund pool to achieve upstream and downstream allocation and collection of funds, and improve the efficiency of fund utilization. Provide real-time, accurate, and comprehensive financial information support for enterprise financial decision-making',
        contentThree: '3.Save time and increase efficiency. All instructions are entered at once, reducing the manual operation and accounting workload of financial personnel, effectively reducing error rates.',
        contentFour: '4.Safe and reassuring. In addition to adopting the same security mechanism as online banking, the "signature time" field has been added to transfer transactions, and the "package sequence ID" field has been added to all transactions, effectively preventing hacker attacks and repeated submission of instructions.'
    },
    contactUs:{
        content:'The pre-sales team provides you with pre-sales consulting, product and solution recommendations, configuration recommendations, and other services to help you open up the interconnection between banks and enterprises, ensuring smooth information flow',
        name: 'Name',
        nameRule: 'Please enter name',
        eMail: 'Email',
        eMailRule: 'Please enter email',
        comp: 'Company Name',
        compRule: 'Please enter the company name',
        position: 'Position',
        positionRule: 'Please enter position',
        mobile: 'Mobile Number',
        mobileRule: 'Please enter your phone number',
        consuContent: 'Consultation Content',
        consuContentRule: 'Please fill in the inquiry content',
        sub: 'Submit'
    },
    showRightDataList:{
        console: 'Console',
        exit: 'Exit',
        register: 'Log in'
    },
    remarks:'Copyright © 2022 Enterprise Application and Bank Direct Connect Platform',
    message:{
        language: 'Successfully set language'
    }
}



// WEBPACK FOOTER //
// ./src/lang/en.js